import * as React from 'react';
import { CardLayout } from '../../common';
import { ReportingProfileContainer } from '../../../containers/reporting/ReportingProfileContainer';
import { DistributionType, ISurveyAdminSummary, SurveyStatusType } from '../../../models';
import ContentConstants from '../../../contentConstants';
import { Permission, Pullout, PulloutType } from '@aon/aon-tws-common-ui';
import HtmlParser from 'html-react-parser';
import PermissionConstants from '../../../permissionConstants';

export interface IReportingProfilesProps {
	distributionType: DistributionType | undefined;
	surveyAdminSummary: ISurveyAdminSummary | undefined;
	surveyId: number;
}

export class AdminReportingProfiles extends React.PureComponent<IReportingProfilesProps> {
	public render() {
		const isLocked = this.props.surveyAdminSummary?.surveyStatus === SurveyStatusType.SurveyClosed;

		return (
			<Permission {...PermissionConstants.HIERARCHYREPORTING_ALL}>
				<CardLayout loading={this.props.distributionType === undefined} title={ContentConstants.SURVEY_ADMIN_ACTION_REPORTING_PROFILES}>
					{isLocked && (
						<>
							<Pullout type={PulloutType.Locked}>{HtmlParser(ContentConstants.SURVEY_ADMIN_REPORTING_PROFILES_LOCKED_MESSAGE)}</Pullout>
							<br />
						</>
					)}
					{this.props.distributionType && (
						<ReportingProfileContainer surveyId={this.props.surveyId} distributionType={this.props.distributionType} />
					)}
				</CardLayout>
			</Permission>
		);
	}
}
